






















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FormatHelper from '~/helpers/format-helper';
import DetailsTravelPack from '~/components/modals/DetailsTravelPack.vue';

@Component({
	components: {
		DetailsTravelPack,
	},
})
export default class CardPackage extends Vue {
	@Prop({ default: null, required: false }) private model;
	$refs!: {
		detailsTravelPack: DetailsTravelPack;
	};

	private value = {};

	@Watch('model')
	modelChange(value) {
		this.value = value;
	}

	created() {
		if (this.model) {
			this.value = this.model;
		}
	}

	get getImgUrl() {
		return process.env.API_IMG_URL + this.value['img_url'];
	}

	formatPrice(value) {
		return FormatHelper.formatPrice(value);
	}

	showModal(selected_tab, event) {
		let tab = 0;
		if (selected_tab == 'activities') {
			// Empieza por el último
			if (
				this.value['extra_service'] &&
				this.value['extra_service'].length &&
				this.value['transport'] &&
				this.value['transport'].id
			) {
				tab = 3;
			} else if (
				(this.value['extra_service'] && this.value['extra_service'].length) ||
				(this.value['transport'] && this.value['transport'].id)
			) {
				tab = 2;
			} else {
				tab = 1;
			}
		} else if (selected_tab == 'extra_service') {
			if (this.value['transport'] && this.value['transport'].id) {
				tab = 2;
			} else {
				tab = 1;
			}
		} else if (selected_tab == 'transport') {
			tab = 1;
		}
		this.$refs.detailsTravelPack.showModal(tab);
	}
}
